/**
 * First sort by feature display Name, then by action
 */
export function permissionSort(perm1, perm2) {
    const permToString = (perm) => {
        const parts = perm.displayName.toUpperCase().split(' ');
        return parts.slice(1).join(' ') + parts[0];
    };
    return permToString(perm1).localeCompare(permToString(perm2));
}
